import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import api from '../../api';
import adapter from './adapter';
import service from './service'

const { responseBodyToRender } = adapter
const { getData } = service

const initialState = {
  _payload: null,
  status: 'idle',
  error: '',
  data: {},
}

export const fetchResource = createAsyncThunk('resource/fetchResource', async (id) => {
  const data = await getData(id)
  return data
})

export const resourceSlice = createSlice({
  name: 'resource',
  initialState,
  reducers: {
    setStatus(state, action){
      state.status = action.payload
    },
  },
  extraReducers: {
    // Resource | Single
    [fetchResource.pending]: (state) => {
      state.status = 'loading'
    },
    [fetchResource.fulfilled]: (state, action) => {
      state.status = 'succeeded'
      const resource = action.payload.results
      const payload = api.resources_available ? responseBodyToRender(resource) : action.payload
      state.data = payload
    },
    [fetchResource.rejected]: (state, action) => {
      state.status = 'failed'
      state.error = action.error.message
    },
  }
})

export const {
  setStatus,
} = resourceSlice.actions

export default resourceSlice.reducer
